"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERRORS = exports.ErrorCode = void 0;
const StatusCodeEnum_1 = require("./../../lib/infrastructure/StatusCodeEnum");
var ErrorCode;
(function (ErrorCode) {
    ErrorCode["E001"] = "E001";
    ErrorCode["E002"] = "E002";
    ErrorCode["E003"] = "E003";
    ErrorCode["E004"] = "E004";
    ErrorCode["E005"] = "E005";
    ErrorCode["E006"] = "E006";
    ErrorCode["E007"] = "E007";
    ErrorCode["E008"] = "E008";
    ErrorCode["E009"] = "E009";
    ErrorCode["E010"] = "E010";
    ErrorCode["E011"] = "E011";
    ErrorCode["E012"] = "E012";
    ErrorCode["E013"] = "E013";
    ErrorCode["E014"] = "E014";
    ErrorCode["E015"] = "E015";
    ErrorCode["E016"] = "E016";
    ErrorCode["E017"] = "E017";
    ErrorCode["E018"] = "E018";
})(ErrorCode = exports.ErrorCode || (exports.ErrorCode = {}));
exports.ERRORS = {
    [ErrorCode.E001]: {
        code: ErrorCode.E001,
        message: "El cuerpo de la petición es inválido.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest,
    },
    [ErrorCode.E002]: {
        code: ErrorCode.E002,
        message: "Ha ocurrido un error inesperado.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.InternalServerError,
    },
    [ErrorCode.E003]: {
        code: ErrorCode.E003,
        message: "La tarjeta no permite realizar pagos diferidos.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest,
    },
    [ErrorCode.E004]: {
        code: ErrorCode.E004,
        message: "Id de comercio no válido.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest,
    },
    [ErrorCode.E005]: {
        code: ErrorCode.E005,
        message: "El número de tarjeta no es válido.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest,
    },
    [ErrorCode.E006]: {
        code: ErrorCode.E006,
        message: "Error de validación apple pay.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest,
    },
    [ErrorCode.E007]: {
        code: ErrorCode.E007,
        message: "Error al iniciar sesión.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest,
    },
    [ErrorCode.E008]: {
        code: ErrorCode.E008,
        message: "Código incorrecto, ingresar nuevamente.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest,
    },
    [ErrorCode.E009]: {
        code: ErrorCode.E009,
        message: "Error al validar sesión.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest,
    },
    [ErrorCode.E010]: {
        code: ErrorCode.E010,
        message: "Es necesaria la verificación de autenticación del usuario.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest,
    },
    [ErrorCode.E011]: {
        code: ErrorCode.E011,
        message: "Sesión no disponible.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest,
    },
    [ErrorCode.E012]: {
        code: ErrorCode.E012,
        message: "Campos 3DS inválidos",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest,
    },
    [ErrorCode.E013]: {
        code: ErrorCode.E013,
        message: "Comercio no tiene activo 3DS",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest,
    },
    [ErrorCode.E014]: {
        code: ErrorCode.E014,
        message: "Longitud de tarjeta inválida",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest,
    },
    [ErrorCode.E015]: {
        code: ErrorCode.E015,
        message: "Configuración de credenciales Sift inválidas",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest,
    },
    [ErrorCode.E016]: {
        code: ErrorCode.E016,
        message: "Error al generar animación.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.InternalServerError,
    },
    [ErrorCode.E017]: {
        code: ErrorCode.E017,
        message: "Marca de tarjeta inválida.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.BadRequest,
    },
    [ErrorCode.E018]: {
        code: ErrorCode.E018,
        message: "No se cargaron los recursos para validación con 3DS.",
        statusCode: StatusCodeEnum_1.StatusCodeEnum.InternalServerError,
    },
};
